// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1B7YD","clinicsSelect":"TableHeading_clinicsSelect__2TnkA"};